import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Delete } from "@mui/icons-material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useState } from "react";
import { ConfirmDialog } from "./ConfirmDialog";
const GridDeleteCellItem = ({ confirmTitle, confirmDescription, confirmNote, onConfirm, sx, }) => {
    const [isConfirmOpen, setConfirmOpen] = useState(false);
    const handleCloseConfirm = () => {
        setConfirmOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(GridActionsCellItem, { icon: _jsx(Delete, {}), onClick: () => setConfirmOpen(true), label: "Delete", color: "inherit", sx: sx, children: _jsx(Delete, { fontSize: "small" }) }, "delete"), _jsx(ConfirmDialog, { title: confirmTitle, description: confirmDescription, open: isConfirmOpen, onCancel: handleCloseConfirm, onConfirm: () => {
                    onConfirm();
                    handleCloseConfirm();
                }, note: confirmNote })] }));
};
export default GridDeleteCellItem;
